<template>
  <div class="wg-location">
    <div class="themesflat-container">
      <div class="row">
        <MapLocationComponent/>
        <div class="col-md-6">
          <div class="content">
            <div class="heading-section text-center">
              <div class="sub ">{{ $t('location') }}</div>
              <div class="main " :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ $t('how_to_find_us') }}</div>
              <div class="divider "><div></div></div>
            </div>
            <div class="title ">{{ $t('make_a_call') }} & {{ $t('address') }}:</div>
            <div class="number ">{{ contact.phone }}</div>
            <p class="">
              {{ contact.address }}, {{ contact.city }}, {{ contact.country }} <br>
              {{ contact.shop_email }}
            </p>
            <div class="title ">{{ $t('opening_hours') }}:</div>
            <p class="text ">
              {{ $t('monday') }} - {{ $t('sunday') }} : {{ openHour.open_time_hours_from }} - {{ openHour.open_time_hours_to }} <br>
               {{ $t('delivery') }} : {{ openHour.delivery_time_from }} - {{ openHour.delivery_time_to }}
            </p>
            <!-- <a class="button-two-line  m-auto" href="menu-1.html"
              >GET DIRECTIONS</a
            > -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MapLocationComponent from "@/components/home/MapLocationComponent.vue";
import { langStore } from "../../langStore";
// eslint-disable-next-line
/* global google */
export default {
  name: "LocationComponent",
  components: {
    MapLocationComponent
  },
  data() {
    return {
      contact: {},
      openHour: {},
      langStore
    };
  },

  mounted() {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/api/setting`)
      .then((response) => {
        this.contact = response.data;
      })
      .catch((error) => {
        console.error("There was an error fetching the data:", error);
      });

      axios
      .get(`${process.env.VUE_APP_BASE_URL}/api/open-hour`)
      .then((response) => {
        this.openHour = response.data;
      })
      .catch((error) => {
        console.error("There was an error fetching the data:", error);
      });
  },

  methods: {
    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + photo;
    },
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
